import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MessageSquareIcon, MapPinIcon, PhoneIcon, MailIcon, ClockIcon, CheckCircleIcon } from 'lucide-react';
export function RequestInfoPage() {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    location: '',
    topic: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setForm(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  const inputClass = 'w-full px-4 py-3.5 border border-gray-200 bg-white text-black text-sm placeholder-gray-400 focus:outline-none focus:border-[#822433] transition-colors';
  return <div data-id="element-833">
      {/* Hero */}
      <div className="relative py-24 px-4 sm:px-6 lg:px-8 text-center overflow-hidden" style={{
      background: '#000000'
    }} data-id="element-834">
        <img src="https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=1600&q=80" alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover opacity-20" data-id="element-835" />
        <div className="relative z-10" data-id="element-836">
          <p className="text-xs font-bold uppercase mb-3" style={{
          color: '#CC0000',
          letterSpacing: '0.2em'
        }} data-id="element-837">
            We're Here to Help
          </p>
          <h1 className="text-4xl sm:text-6xl font-black text-white mb-4" data-id="element-838">
            Request Information
          </h1>
          <div className="w-12 h-0.5 mx-auto mb-6" style={{
          background: '#FECB00'
        }} data-id="element-839" />
          <p className="text-gray-400 text-base max-w-xl mx-auto leading-relaxed" data-id="element-840">
            Have a question about our services, pricing, or locations? Send us a
            message and we'll get back to you fast.
          </p>
        </div>
      </div>

      {/* 2-col: Form + Contact Info */}
      <section className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-841">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-842">
          {/* LEFT: Form */}
          <div data-id="element-843">
            <p className="text-xs font-bold uppercase mb-4" style={{
            color: '#CC0000',
            letterSpacing: '0.2em'
          }} data-id="element-844">
              Send a Message
            </p>
            <h2 className="font-black text-black text-3xl sm:text-4xl leading-tight mb-2" data-id="element-845">
              How Can We Help?
            </h2>
            <div className="w-10 h-0.5 mb-8" style={{
            background: '#FECB00'
          }} data-id="element-846" />

            {submitted ? <div className="text-center py-16 bg-[#F5F5F5] p-10" data-id="element-847">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-5" data-id="element-848">
                  <CheckCircleIcon size={32} className="text-green-500" data-id="element-849" />
                </div>
                <h3 className="text-2xl font-black text-black mb-3" data-id="element-850">
                  Message Sent!
                </h3>
                <p className="text-base max-w-sm mx-auto mb-8" style={{
              color: '#616365'
            }} data-id="element-851">
                  We've received your request and will respond within 24 hours.
                  For urgent matters, call us directly.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-852">
                  <button onClick={() => {
                setSubmitted(false);
                setForm({
                  name: '',
                  email: '',
                  phone: '',
                  location: '',
                  topic: '',
                  message: ''
                });
              }} className="inline-block font-black text-sm uppercase tracking-widest px-8 py-4 transition-colors duration-200" style={{
                border: '2px solid #CC0000',
                color: '#CC0000'
              }} onMouseEnter={e => {
                e.currentTarget.style.background = '#CC0000';
                e.currentTarget.style.color = '#fff';
              }} onMouseLeave={e => {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.color = '#CC0000';
              }} data-id="element-853">
                    Send Another
                  </button>
                  <Link to="/" className="inline-block text-white font-black text-sm uppercase tracking-widest px-8 py-4 transition-colors duration-200" style={{
                background: '#CC0000'
              }} onMouseEnter={e => e.currentTarget.style.background = '#AA0000'} onMouseLeave={e => e.currentTarget.style.background = '#CC0000'} data-id="element-854">
                    Back to Home
                  </Link>
                </div>
              </div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-855">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-856">
                  <input name="name" value={form.name} onChange={handleChange} placeholder="Your Name *" required className={inputClass} data-id="element-857" />
                  <input type="email" name="email" value={form.email} onChange={handleChange} placeholder="Email Address *" required className={inputClass} data-id="element-858" />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-859">
                  <input type="tel" name="phone" value={form.phone} onChange={handleChange} placeholder="Phone Number" className={inputClass} data-id="element-860" />
                  <select name="location" value={form.location} onChange={handleChange} className={inputClass} data-id="element-861">
                    <option value="" data-id="element-862">Preferred Location</option>
                    <option value="cottage-city" data-id="element-863">Cottage City</option>
                    <option value="capitol-heights" data-id="element-864">Capitol Heights</option>
                    <option value="suitland" data-id="element-865">Suitland</option>
                    <option value="any" data-id="element-866">Any Location</option>
                  </select>
                </div>
                <select name="topic" value={form.topic} onChange={handleChange} required className={inputClass} data-id="element-867">
                  <option value="" data-id="element-868">Topic / Subject *</option>
                  <option value="tire-pricing" data-id="element-869">
                    Tire Pricing & Availability
                  </option>
                  <option value="services" data-id="element-870">Service Information</option>
                  <option value="fleet" data-id="element-871">Fleet Services</option>
                  <option value="partnership" data-id="element-872">Partnership Inquiry</option>
                  <option value="complaint" data-id="element-873">Feedback / Complaint</option>
                  <option value="other" data-id="element-874">Other</option>
                </select>
                <textarea name="message" value={form.message} onChange={handleChange} placeholder="Your message or question... *" rows={5} required className={inputClass} style={{
              resize: 'none'
            }} data-id="element-875" />
                <button type="submit" className="w-full text-white font-black uppercase tracking-widest py-4 text-sm transition-colors duration-200" style={{
              background: '#822433'
            }} onMouseEnter={e => e.currentTarget.style.background = '#6B1D29'} onMouseLeave={e => e.currentTarget.style.background = '#822433'} data-id="element-876">
                  Send Message
                </button>
              </form>}
          </div>

          {/* RIGHT: Contact Info */}
          <div data-id="element-877">
            <p className="text-xs font-bold uppercase mb-4" style={{
            color: '#CC0000',
            letterSpacing: '0.2em'
          }} data-id="element-878">
              Contact Details
            </p>
            <h2 className="font-black text-black text-3xl sm:text-4xl leading-tight mb-2" data-id="element-879">
              Reach Us Directly
            </h2>
            <div className="w-10 h-0.5 mb-8" style={{
            background: '#FECB00'
          }} data-id="element-880" />

            <div className="space-y-6 mb-10" data-id="element-881">
              <div className="flex items-start gap-4" data-id="element-882">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                background: 'rgba(204,0,0,0.10)'
              }} data-id="element-883">
                  <PhoneIcon size={20} style={{
                  color: '#CC0000'
                }} data-id="element-884" />
                </div>
                <div data-id="element-885">
                  <p className="font-black text-black text-base mb-1" data-id="element-886">Phone</p>
                  <a href="tel:3012549001" className="text-base font-semibold transition-colors" style={{
                  color: '#CC0000'
                }} onMouseEnter={e => e.currentTarget.style.color = '#AA0000'} onMouseLeave={e => e.currentTarget.style.color = '#CC0000'} data-id="element-887">
                    (301) 254-9001
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-888">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                background: 'rgba(204,0,0,0.10)'
              }} data-id="element-889">
                  <MailIcon size={20} style={{
                  color: '#CC0000'
                }} data-id="element-890" />
                </div>
                <div data-id="element-891">
                  <p className="font-black text-black text-base mb-1" data-id="element-892">Email</p>
                  <a href="mailto:info@ameritechtires.com" className="text-base font-semibold transition-colors" style={{
                  color: '#CC0000'
                }} onMouseEnter={e => e.currentTarget.style.color = '#AA0000'} onMouseLeave={e => e.currentTarget.style.color = '#CC0000'} data-id="element-893">
                    info@ameritechtires.com
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-894">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                background: 'rgba(204,0,0,0.10)'
              }} data-id="element-895">
                  <ClockIcon size={20} style={{
                  color: '#CC0000'
                }} data-id="element-896" />
                </div>
                <div data-id="element-897">
                  <p className="font-black text-black text-base mb-1" data-id="element-898">Hours</p>
                  <p className="text-sm font-semibold text-green-600" data-id="element-899">
                    Open 24 Hours — Every Day
                  </p>
                  <p className="text-sm mt-0.5" style={{
                  color: '#616365'
                }} data-id="element-900">
                    All 3 DMV locations
                  </p>
                </div>
              </div>
            </div>

            <div className="space-y-4" data-id="element-901">
              {[{
              name: 'Cottage City',
              address: '4014 Bladensburg Rd, Cottage City, MD 20722'
            }, {
              name: 'Capitol Heights',
              address: '1205 Marblewood Ave, Capitol Heights, MD 20743'
            }, {
              name: 'Suitland',
              address: '4510 Suitland Rd, Suitland, MD 20746'
            }].map(loc => <div key={loc.name} className="flex items-start gap-3 p-4" style={{
              background: '#F5F5F5',
              borderLeft: '3px solid #CC0000'
            }} data-id="element-902">
                  <MapPinIcon size={16} className="flex-shrink-0 mt-0.5" style={{
                color: '#CC0000'
              }} data-id="element-903" />
                  <div data-id="element-904">
                    <p className="font-black text-black text-sm" data-id="element-905">{loc.name}</p>
                    <p className="text-xs mt-0.5" style={{
                  color: '#616365'
                }} data-id="element-906">
                      {loc.address}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ strip */}
      <section className="w-full py-16 px-4 sm:px-6 lg:px-8" style={{
      background: '#111111'
    }} data-id="element-907">
        <div className="max-w-4xl mx-auto text-center" data-id="element-908">
          <p className="text-xs font-bold uppercase mb-3" style={{
          color: '#CC0000',
          letterSpacing: '0.2em'
        }} data-id="element-909">
            Quick Answers
          </p>
          <h2 className="font-black text-white text-2xl sm:text-3xl mb-10" data-id="element-910">
            Common Questions
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left" data-id="element-911">
            {[{
            q: 'Do I need an appointment?',
            a: 'No! Walk-ins are always welcome at all 3 locations. Just drive in anytime.'
          }, {
            q: 'How long does a tire service take?',
            a: 'Most services are completed in under 45 minutes. We respect your time.'
          }, {
            q: 'What brands do you carry?',
            a: 'Michelin, Goodyear, Bridgestone, Continental, Pirelli, and many more.'
          }, {
            q: 'Do you offer fleet pricing?',
            a: 'Yes — contact us for volume discounts and dedicated fleet service plans.'
          }].map(({
            q,
            a
          }) => <div key={q} className="p-6" style={{
            background: '#1a1a1a'
          }} data-id="element-912">
                <p className="font-black text-white text-sm mb-2" data-id="element-913">{q}</p>
                <p className="text-sm leading-relaxed" style={{
              color: '#616365'
            }} data-id="element-914">
                  {a}
                </p>
              </div>)}
          </div>
        </div>
      </section>
    </div>;
}